import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgMiniQuestion = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.5 8.035a4.77 4.77 0 01.507-.406 3.508 3.508 0 011.277-.549c.247-.053.512-.08.796-.08.393 0 .748.057 1.067.171.319.115.591.278.819.49.227.212.402.467.527.766.124.298.186.632.186 1a2.7 2.7 0 01-.14.92 2.633 2.633 0 01-.822 1.171l-.485.392a3.642 3.642 0 00-.396.36.774.774 0 00-.206.395l-.095.581a.5.5 0 01-.494.42h-.364a.5.5 0 01-.497-.446l-.076-.688a.982.982 0 01.079-.584c.083-.165.194-.317.334-.454l.222-.203.246-.196c.172-.128.334-.266.484-.413a2.11 2.11 0 00.38-.496c.103-.184.154-.402.154-.654 0-.308-.1-.553-.298-.734-.198-.182-.462-.273-.789-.273-.24 0-.442.028-.606.084a2.435 2.435 0 00-.422.185c-.118.068-.218.13-.301.185a.4.4 0 01-.609-.147L9.5 8.035zm1.224 7.853c0-.154.028-.3.082-.437a1.087 1.087 0 01.563-.595c.13-.058.27-.087.423-.087.148 0 .288.029.419.087a1.066 1.066 0 01.566.595c.055.137.082.283.082.437a1.152 1.152 0 01-.308.794 1.056 1.056 0 01-.76.318 1.032 1.032 0 01-.76-.318 1.098 1.098 0 01-.225-.353 1.166 1.166 0 01-.082-.441z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgMiniQuestion.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgMiniQuestion;
